import {Policy} from '../../common/fields/policy';
import {FieldEvent} from './settings';
import {fieldArts as arts} from '../../artjs/field';

export function createPOLICY(d) {
  FieldEvent[d.fieldName] = new Policy(d);
  return FieldEvent[d.fieldName];
}


export function changePOLICY(e, d) {
  const field = FieldEvent[d];
  field.setValue(e.checked);
  renderPOLICY(d);
}

export function renderPOLICY(d){
  const field = FieldEvent[d];
  if(!field.dom){
    field.dom = document.getElementById(`sk-field-${d}`);
  }
  if(field.dom){
    field.dom.innerHTML = arts.FIELDPOLICY.pc({field: field});
  }
}
